module.exports = __webpack_public_path__ + "assets/rental-duration.15e0898d.svg";